import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PmdTableHeaderFixed } from './fixed-header.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PmdTableHeaderFixed
  ],
  exports: [
    PmdTableHeaderFixed
  ]
})
export class PmdFixedHeaderModule { }
